export default __webpack_public_path__ + "static/comparisons-eda-d3a6a0d4975cd407e1a7bcebd60010d9.webp";